<script setup lang="ts">
import { useMobileStore } from '@/store/mobile';
import { storeToRefs } from 'pinia';
import NavIconTitle from './nav/NavIconTitle.vue';
import ThemeToggle from './ThemeToggle.vue';

const { toggleMenu } = useMobileStore();
const { showMenu } = storeToRefs(useMobileStore());
</script>

<template>
  <v-app-bar elevation="0" height="64" class="the-navbar" :class="{ 'the-navbar--menu-open': showMenu }">
    <v-app-bar-nav-icon
      class="mr-4 ml-n1"
      flat
      variant="plain"
      :height="24"
      :width="24"
      :active="showMenu"
      @click="toggleMenu()"
    >
      <v-icon icon="mdi-menu" size="24" class="nav-menu-icon" />
    </v-app-bar-nav-icon>

    <NavIconTitle />

    <div id="nav-search"></div>

    <template #append>
      <ClientOnly>
        <ThemeToggle class="mr-2" />
      </ClientOnly>
      <div id="cart-append"></div>
    </template>
  </v-app-bar>
</template>

<style lang="scss" scoped>
:deep(.v-toolbar__content) {
  max-width: 1280px;
  margin: auto;
  overflow: visible;
  padding-inline: 32px;

  #nav-search:not(:empty) {
    position: relative;
    z-index: 2;
    min-width: 0;
    overflow: visible;
    padding-inline: 24px;
    flex-grow: 1;
  }

  .v-toolbar__append {
    margin-inline-end: -4px;
  }
}

.the-navbar {
  z-index: 1200 !important;
  overflow: visible;
  border-bottom: 0.5px solid rgb(var(--v-theme-stroke));

  &--menu-open {
    z-index: 1000 !important;
  }

  &__mobile {
    display: none;
  }

  &__mobile-menu {
    display: none;
    position: fixed;
    // @NOTE: Header height
    top: 72px;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    .v-list {
      height: 100%;
    }
  }
}

.nav-menu-icon {
  color: rgb(var(--v-theme--primary));
}

@media (max-width: 768px) {
  :deep(.v-toolbar__content) {
    padding-inline: 16px;

    .v-toolbar__append {
      margin-inline: auto 4px;
    }
  }

  .the-navbar {
    padding-inline: 26px;
    border-bottom: none;

    &__profile {
      display: none;
    }

    &__mobile {
      display: block;
    }

    &__mobile-menu {
      display: block;
    }
  }
}

@media (max-width: 768px) {
  .the-navbar {
    padding-inline: 0px;
  }

  .v-toolbar__content > .v-btn:first-child {
    margin-inline-start: 0px !important;
  }
}
</style>
